@let stationsValue = stations();
@let dayValue = day();
@let stationTimeValue = stationTime();
@let selectedTimeStepValue = selectedTimeStep();
<table class="matrix">
  @let timeStepsValue = timeSteps();
  <thead>
    <tr class="matrix-header">
      <th class="station-header-hidden"></th>
      @for (hour of timeStepsValue; track $index) {
        <th
          [ngClass]="
            hour
              | hourClass
                : selectedTimeStepValue
                : stationsValue
                : stationTimeValue
          "
          (click)="onHourClick(hour)">
          {{ hour | number: '2.0' }}
        </th>
      }
    </tr>
  </thead>

  @if (stationsValue.length > 0) {
    <tbody>
      @for (station of stationsValue; track $index; let i = $index) {
        <tr>
          <td class="place-name-container" width="0">
            <span class="place-name">
              {{ station.stationId }} {{ station.name }}
            </span>
          </td>
          @for (hour of timeStepsValue; track $index; let isFirst = $first) {
            <td
              [ngClass]="
                i
                  | indexClass
                    : station.stationId
                    : 'pigeonIndex'
                    : hour
                    : dayValue
                    : false
                    : matrixArray()
                    : mosData()
                    : stationTimeValue
                    : selectedTimeStepValue
                    : selectedStationIndex()
                    : pigeonsService.day()
                    : pigeonsService.mosData()
              "
              [tp]="matrixPopup"
              [tpData]="{ station: station, hour }"
              tpVariation="popper"
              trigger="manual"
              tpPlacement="bottom"
              [tpIsLazy]="true"
              [tpInteractive]="true"
              [tpIsVisible]="
                hour | isPopupVisible: station.stationId : popupVisible()
              "
              #tooltips="tippy"
              (click)="onMatrixClick(hour, station.stationId, i)"></td>
          }
        </tr>
      }
    </tbody>
  }
</table>

<ng-template #matrixPopup let-data="data">
  <h3 style="display: flex; align-items: center">
    {{ data.station.name }} - {{ data.hour | number: '2.0' }}:00
    <span style="flex: auto; overflow: auto"></span>
    <button
      mat-icon-button
      (click)="showTooltipForCell(data.station.stationId, data.hour, false)">
      <fa-icon [icon]="['far', 'times']"></fa-icon>
    </button>
  </h3>

  @let popupDataValue = popupData();
  <table style="width: 300px; table-layout: fixed">
    <tr>
      @for (line of popupDataValue; track $index) {
        <th [tp]="'PRODUCT.PIGEONS.PARAMETER.' + line.parameter | translate">
          <fa-icon [icon]="['far', line['icon']]"></fa-icon>
        </th>
      }
    </tr>
    <tr>
      @for (line of popupDataValue; track $index) {
        <td align="center" [ngStyle]="{ backgroundColor: line.color }">
          {{ line.value }}
        </td>
      }
    </tr>
  </table>
</ng-template>
